import { render } from "./update-subsection.vue?vue&type=template&id=6bbaac5c&scoped=true"
import script from "./update-subsection.vue?vue&type=script&lang=js"
export * from "./update-subsection.vue?vue&type=script&lang=js"

import "./update-subsection.vue?vue&type=style&index=0&id=6bbaac5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbaac5c"],['__file',"src/components/applications/module/update-subsection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bbaac5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bbaac5c', __exports__)) {
    api.reload('6bbaac5c', __exports__)
  }
  
  module.hot.accept("./update-subsection.vue?vue&type=template&id=6bbaac5c&scoped=true", () => {
    api.rerender('6bbaac5c', render)
  })

}


export default __exports__